import React from 'react'
import Link from 'gatsby-link'
import { Row, Col } from 'reactstrap'
import Reference from '../components/reference'
import gasLogo from './images/customers/ga-service.jpg'
import inkoLogo from './images/customers/inko.jpg'
import woelflederLogo from './images/customers/woelfleder.jpg'
import viertbauerLogo from './images/customers/viertbauer.jpg'
import wienenergieLogo from './images/customers/wien_energie.jpg'
import linzagLogo from './images/customers/linz_ag.jpg'
import nnproLogo from './images/customers/nnpro.png'

const Referenzen = () =>
  <Row className="text-center shadow-sm">
    <Col xs="6" md="3" className="border border-right-0 d-flex flex-column bg-light align-items-center justify-content-center">
      <Link to="/kontakt">
        <span className="d-block h1">+</span>
        <h5 className="m-0">Hinzufügen</h5>
      </Link>
    </Col>
    <Col xs="6" md="3" className="border border-right-0 d-flex">
      <Reference image={wienenergieLogo} name="Wien Energie" additionalClass="p-4 p-lg-3" />
    </Col>
    <Col xs="6" md="3" className="border border-right-0 d-flex">
      <Reference image={linzagLogo} name="Linz AG" additionalClass="p-4 p-lg-3" />
    </Col>
    <Col xs="6" md="3" className="border border-right-0 d-flex">
      <Reference image={viertbauerLogo} name="Foto Viertbauer" additionalClass="p-4 p-lg-45" />
    </Col>
    <Col xs="6" md="3" className="border border-right-0 d-flex">
      <Reference image={woelflederLogo} name="Wölfleder GmbH" additionalClass="p-2" />
    </Col>
    <Col xs="6" md="3" className="border border-right-0 d-flex">
      <Reference image={inkoLogo} name="INKO Linz" additionalClass="p-3" />
    </Col>
    <Col xs="6" md="3" className="border border-right-0 d-flex">
      <Reference image={nnproLogo} name="N!N pro GmbH" additionalClass="p-3" />
    </Col>
    <Col xs="6" md="3" className="border d-flex">
      <Reference image={gasLogo} name="INKO Linz" additionalClass="G.A. Service GmbH" />
    </Col>
  </Row>

export default Referenzen;


// WEBPACK FOOTER //
// ./src/components/referenzen.js